﻿import Rect from "../shared/rect";

class DownloadsCtrl {
	constructor(
		$scope,
		$timeout,
		LocationService
	) {
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.locationService = LocationService;
	}

	onIndexItemClick(categoryId) {
		var $target = $("[data-index-id='" + categoryId + "']");

		$('html, body').stop().animate({
			'scrollTop': $target.offset().top
		}, 750, 'swing', function () {});
	}
}

DownloadsCtrl.$inject = ['$scope', '$timeout', 'LocationService'];

export default DownloadsCtrl;
